function isServerSide() {
  return typeof window === 'undefined';
}

// Source: https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
function isClientSide() {
  return !isServerSide();
}
function isMacUserAgent() {
  return window && window.navigator && /(Mac)/i.test(window.navigator.platform);
}
function isAndroidUserAgent() {
  if (isServerSide()) {
    return false;
  }
  const {
    userAgent
  } = window.navigator;
  return /android/i.test(userAgent);
}
function isIOSUserAgent() {
  if (isServerSide()) {
    return false;
  }
  const {
    userAgent
  } = window.navigator;
  return /(iphone|ipad|ipod)/i.test(userAgent) || userAgent.includes('Mac') && 'ontouchend' in document;
}
function isEdgeUserAgent() {
  if (isServerSide()) {
    return false;
  }
  const {
    userAgent
  } = window.navigator;
  const edge = userAgent.indexOf('Edge/');

  // Pre-Chromium Edge (IE 12+) => return version number
  return edge > 0 ? parseInt(userAgent.substring(edge + 5, userAgent.indexOf('.', edge)), 10) : false;
}

export { isAndroidUserAgent, isClientSide, isEdgeUserAgent, isIOSUserAgent, isMacUserAgent, isServerSide };
